import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  questions: [],
  current: 0,
  score: 0,
  completed: false,
  timeLeft: 30 * 60, // 30 minutes in seconds
  quizDate: null,    // persisted so location.state isn't needed after refresh
};

const megaQuizSlice = createSlice({
  name: "megaQuiz",
  initialState,
  reducers: {
    initQuiz(state, action) {
      // Called once when quiz loads for the first time
      state.questions     = action.payload.questions;
      state.quizDate      = action.payload.quizDate;
      state.current       = 0;
      state.score         = 0;
      state.completed     = false;
      state.timeLeft      = 30 * 60;
    },
    setQuestions(state, action) {
      state.questions = action.payload;
    },
    nextQuestion(state) {
      state.current  += 1;
      // selected is local UI state — no need to persist it
    },
    addScore(state, action) {
      state.score += action.payload; // pass 5 on correct answer
    },
    tickTimer(state) {
      if (state.timeLeft > 0) state.timeLeft -= 1;
    },
    setTimeLeft(state, action) {
      state.timeLeft = action.payload;
    },
    setCompleted(state) {
      state.completed = true;
    },
    resetQuiz(state) {
      return initialState;
    },
  },
});

export const {
  initQuiz,
  setQuestions,
  nextQuestion,
  addScore,
  tickTimer,
  setTimeLeft,
  setCompleted,
  resetQuiz,
} = megaQuizSlice.actions;

export default megaQuizSlice.reducer;